import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useField, useFormikContext } from "formik";
import { useIntl } from "react-intl";
import { Row } from "../../Layout/utils";
import { FormValues } from "./CreateFilterKpiForm";
import { FormatType, IconOptions, Kpi } from "./FilterType";
import { KpiOperatorField } from "./KpiOperatorField";
import { KpiValueField } from "./KpiValueField";
import { formInputsStyles } from "../../Configuration/styles";

/**
 * Component to input the value linked to a kpi's choices
 *
 * We must cast the value to a string for the comparison to work
 * All values are cast because of the [input]
 *
 * @param kpi
 * @constructor
 */
export const IconValueField = ({ kpi }: { kpi: Kpi }) => {
  const intl = useIntl();
  const [field] = useField("value");
  const format = kpi.format as IconOptions;
  const choices = format.choices || [
    { value: 0, label: "NO" },
    { value: 1, label: "YES" },
  ];

  return (
    <FormControl variant="standard" component="fieldset">
      <RadioGroup {...field}>
        {choices.map((choice) => (
          <FormControlLabel
            key={choice.value}
            value={choice.value.toString()}
            control={<Radio color="primary" />}
            label={intl.formatMessage({ id: choice.label })}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export const KpiValueSetter = () => {
  const inputStyles = formInputsStyles();
  const {
    values: { kpi },
  } = useFormikContext<FormValues>();

  return (
    <>
      {kpi && (
        <Row
          className={inputStyles.classes.container}
          sx={{
            gap: 1,
            width: "100%",
          }}
        >
          {kpi.format.type === FormatType.ICON && <IconValueField kpi={kpi} />}
          {kpi.format.type !== FormatType.ICON && (
            <>
              <KpiOperatorField />
              <Box
                sx={{
                  flex: "auto",
                }}
              >
                <KpiValueField />
              </Box>
            </>
          )}
        </Row>
      )}
    </>
  );
};
